import { render, staticRenderFns } from "./complaintManageEdit.vue?vue&type=template&id=11e7a65b&scoped=true"
import script from "./complaintManageEdit.vue?vue&type=script&lang=js"
export * from "./complaintManageEdit.vue?vue&type=script&lang=js"
import style0 from "./complaintManageEdit.vue?vue&type=style&index=0&id=11e7a65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e7a65b",
  null
  
)

export default component.exports